import { Shimmer } from '@wartek-id/shimmer'

export const CategoryListItemPreloader = () => (
  <Shimmer height="76px" width="100%" />
)
export const CategoryListPreloader = ({
  isDesktop,
}: {
  isDesktop?: boolean
}) => (
  <div className={isDesktop ? 'space-y-0 grid grid-cols-2 gap-4' : 'space-y-4'}>
    {Array.from({ length: 10 })?.map((_, index) => (
      <CategoryListItemPreloader key={index} />
    ))}
  </div>
)
